var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuestionSymbol = function SvgQuestionSymbol(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.635 3.193C6.313 3.395 5.8 4.53 5.71 5.07c-.116.297-.44.416-.587.439-.27.011-.845-.085-.846-.72 0-.705.7-1.873 1.853-2.445.658-.326 2.74-.674 4.171.27 1.196.788 1.69 2.206 1.285 3.56-.228.764-1.389 1.82-2.12 2.467-.731.648-.877 1.429-.877 1.987 0 .392-.282.454-.66.454h-.006c-.23 0-.68 0-.711-.288-.122-1.107.2-1.916 1.098-2.879.741-.796 2.076-1.555 1.937-2.767-.111-.97-1.072-2.19-2.612-1.955M8.767 13.153a.85.85 0 1 1-1.7 0 .85.85 0 0 1 1.7 0"
  })));
};
export default SvgQuestionSymbol;